export default __webpack_public_path__ + "static/media/jellyboss.49701e68.png";